import React from 'react';
import { translations } from '../translations';
import '../styles/pages/Terms.css';

function Terms({ language }) {
  const t = translations[language];

  return (
    <div className="terms-page">
      <div className="terms-hero">
        <h1>{t.termsTitle}</h1>
        <p>{t.termsSubtitle}</p>
      </div>

      <div className="terms-content">
        <section className="terms-section">
          <h2>{t.termsIntroTitle}</h2>
          <p>{t.termsIntroText}</p>
        </section>

        <section className="terms-section">
          <h2>{t.accountTitle}</h2>
          <p>{t.accountText}</p>
          <ul>
            <li>{t.accountItem1}</li>
            <li>{t.accountItem2}</li>
            <li>{t.accountItem3}</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>{t.usageTitle}</h2>
          <p>{t.usageText}</p>
          <h3>{t.prohibitedTitle}</h3>
          <ul>
            <li>{t.prohibitedItem1}</li>
            <li>{t.prohibitedItem2}</li>
            <li>{t.prohibitedItem3}</li>
            <li>{t.prohibitedItem4}</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>{t.intellectualPropertyTitle}</h2>
          <p>{t.intellectualPropertyText}</p>
        </section>

        <section className="terms-section">
          <h2>{t.terminationTitle}</h2>
          <p>{t.terminationText}</p>
        </section>

        <section className="terms-section">
          <h2>{t.limitationTitle}</h2>
          <p>{t.limitationText}</p>
        </section>

        <section className="terms-section">
          <h2>{t.governingLawTitle}</h2>
          <p>{t.governingLawText}</p>
        </section>

        <section className="terms-section">
          <h2>{t.changesTitle}</h2>
          <p>{t.changesText}</p>
        </section>

        <section className="terms-section">
          <h2>{t.contactTermsTitle}</h2>
          <p>{t.contactTermsText}</p>
          <p>
            Email: <a href="mailto:support@dysorto.fr">support@dysorto.fr</a>
          </p>
        </section>

        <p className="last-updated">{t.lastUpdated}</p>
      </div>
    </div>
  );
}

export default Terms;
